import { render, staticRenderFns } from "./buttonsCheckAntecedentes.vue?vue&type=template&id=102f22a1"
import script from "./buttonsCheckAntecedentes.vue?vue&type=script&lang=js"
export * from "./buttonsCheckAntecedentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports